"use client";

import { useClientTranslations } from "@/hooks/useClientTranslations";
import { FlowLegend, Tag, WilsonFace } from "@/components/desktop/ui";
import { modesOf, type WarehouseFlowView } from "./warehouseFlow.utils";
import { WarehouseFlowFeedback } from "./WarehouseFlowFeedback";
const LEGEND_KEYS = ["new", "booked", "onHold", "inTransit", "behind", "delivered"] as const;
export function WarehouseFlowEyebrow({
  sampleNote,
  shouldShowMessage
}: {
  sampleNote?: string;
  shouldShowMessage: boolean;
}) {
  const t = useClientTranslations("desktop.warehouseFlow");
  if (sampleNote !== undefined) {
    return <span className="flex flex-wrap items-center gap-2.5 text-xs text-ink-2">
                <Tag tone="lilac">{t("sample.tag")}</Tag>
                {sampleNote}
                <WarehouseFlowFeedback shouldShowMessage={false} />
            </span>;
  }
  return <span className="flex flex-wrap items-center gap-2.5 text-xs text-ink-3" data-sentry-component="WarehouseFlowEyebrow" data-sentry-source-file="WarehouseFlowHeader.tsx">
            <span className="flex items-center gap-2">
                <WilsonFace variant="bare" className="h-3.5" data-sentry-element="WilsonFace" data-sentry-source-file="WarehouseFlowHeader.tsx" />
                {t("eyebrow")}
            </span>
            <WarehouseFlowFeedback shouldShowMessage={shouldShowMessage} data-sentry-element="WarehouseFlowFeedback" data-sentry-source-file="WarehouseFlowHeader.tsx" />
        </span>;
}
export function WarehouseFlowLegend({
  view,
  className
}: {
  view: WarehouseFlowView;
  className?: string;
}) {
  const t = useClientTranslations("desktop.warehouseFlow");
  return <FlowLegend className={className} items={LEGEND_KEYS.filter(key => key !== "onHold" || view.totals.stages.onHold > 0).map(key => ({
    key,
    label: t(`legend.${key}`)
  }))} modes={modesOf(view).map(mode => ({
    mode,
    label: t(`legend.modes.${mode}`)
  }))} data-sentry-element="FlowLegend" data-sentry-component="WarehouseFlowLegend" data-sentry-source-file="WarehouseFlowHeader.tsx" />;
}